$(() => {
  const modifyContent = [];
  const sliderSection = $("main>.bs-section--take-action-quickly-find-section");
  if (sliderSection.length) {
    sliderSection.each((ind, ele) => {
      const firstColElement = $(ele).find(".bs-div"); // first element with heading and paragraph
      if (firstColElement.length != 0) {
        modifyContent.push(firstColElement.html());
      }
    });
    if (modifyContent.length != 0) {
      $(window).on("load resize", (e) => {
        if ($(window).width() > 576) {
          for (let i = 0; i < modifyContent.length; i++) {
            $(sliderSection[i]).find(".bs-slider>div .slider-heading").remove();
            $(sliderSection[i]).find(".bs-slider>div").prepend(`<div class="slider-heading">${modifyContent[i]}</div>`);
            $(sliderSection[i]).find(".bs-div").html("");
          }
        } else {
          for (let i = 0; i < modifyContent.length; i++) {
            $(sliderSection[i]).find(".bs-slider>div .slider-heading").remove();
            $(sliderSection[i]).find(".bs-div").html("");
            $(sliderSection[i]).find(".bs-div").append(modifyContent[i]);
          }
        }
      });
    }
  }
});
